import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import Links from './Links';

const ImageContentSection = props => {
  const items = (
    <React.Fragment>
      <div className="col-xs-12 image-content-section__image">
        <img className="hide-mobile" src={props.desktopImageUrl} />
        <img className="hide-tablet" src={props.mobileImageUrl} />
      </div>
      <div className="col-xs-12 col-md-6 image-content-section__content">
        <div dangerouslySetInnerHTML={{ __html: props.content }} />
        <Links links={props.links} />
      </div>
    </React.Fragment>
  );

  const imageSectionClasses = classNames(
    'row image-content-section',
    props.classNames
  );

  return (
    <div className="content-wrapper">
      <div className={classNames('scalable-content-section', props.styleClass)}>
        <div className={imageSectionClasses}>{items}</div>
      </div>
    </div>
  );
};

ImageContentSection.propTypes = {
  desktopImageUrl: propTypes.string.isRequired,
  mobileImageUrl: propTypes.string.isRequired,
  content: propTypes.string.isRequired,
  links: propTypes.array.isRequired,
  imagePositionClass: propTypes.string,
  styleClass: propTypes.string,
};

export default ImageContentSection;
